import React, { useEffect, useRef, useState } from 'react';
import './styles.css';
import Card from 'react-bootstrap/Card';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEllipsis,
  faRetweet,
  faStar,
  faReply
} from '@fortawesome/free-solid-svg-icons';
import Image from 'react-bootstrap/Image';
import VideoComponent from './VideoComponent';
import { useTranslate } from '@tolgee/react';
import { PREVIEW_TYPE_COMPACT } from '../../config/constants';
import { useSelector, useDispatch } from 'react-redux';
import { setModalUiContent } from '../../../../redux/slices/lomavisCreator/lomavisCreator';
import { COMPACT_MODE_HEIGHT } from '../contants';
import LinkPreview from './linkPreviewComponent';
import { TWITTER } from '../../../../config/constants';
import OnImagesLoaded from '../../../onImagesLoaded';
import PreviewImagesSkeleton from '../loaders/previewImagesSkeleton';
import PlatformIconSkeleton from '../loaders/platformIconSkeleton';
import ImportedPostsMediaPreview from './importedPostsMediaPreview';
import AltTagButton from './buttons/altTagsBtn';

export default function TwitterPostPreview({
  platform = TWITTER,
  cropList = null,
  mediaFiles = null,
  postText = null,
  profileName = null,
  platformIcon = null,
  previewAssets,
  viewAssets,
  previewUrl
}) {
  const {
    ui: { previewMode },
    created_in_lomavis
  } = useSelector((state: any) => state.lomavisCreator);
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const multiImageContainerHeight = '250px';
  const [insets, setInsets] = useState({} as any);
  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  useEffect(() => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
      const handleResize = () => {
        setContainerWidth(containerRef.current.offsetWidth);
      };
      window.addEventListener('resize', handleResize);
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }
  }, []);
  const calculateInsets = () => {
    switch (mediaFiles.length) {
      case 1:
        return {
          img1: {
            inset: '0',
            height:
              containerWidth * (mediaFiles[0].height / mediaFiles[0].width) +
              'px'
          }
        };
      case 2:
        return {
          img1: { inset: '0 calc(50% + 1.01px) 0 0' },
          img2: { inset: '0 0 0 calc(50% + 1.01px)' }
        };
      case 3:
        return {
          img1: { inset: '0 calc(50% + 1.01px) 0 0' },
          img2: { inset: '0 0 calc(50% + 1.01px) calc(50% + 1.01px)' },
          img3: { inset: 'calc(50% + 0px) 0 0 calc(50% + 1.01px)' }
        };
      case 4:
        return {
          img1: { inset: '0 calc(50% + 1.01px) calc(50% + 1.01px) 0' },
          img2: { inset: '0 0 calc(50% + 1.01px) calc(50% + 1.01px)' },
          img3: { inset: 'calc(50% + 0px) calc(50% + 1.01px) 0 0' },
          img4: { inset: 'calc(50% + 0px) 0 0 calc(50% + 1.01px)' }
        };
      default:
        return {};
    }
  };

  useEffect(() => {
    if (mediaFiles) {
      setInsets(calculateInsets());
    }
  }, [mediaFiles, containerWidth, cropList]);

  return (
    <div className="w-100 m-2">
      <Card className="w-100">
        <div className="d-flex flex-row px-2 py-2 w-100">
          <div className="w-50px h-50px">
            <OnImagesLoaded
              onLoaded={() => {}}
              placeholder={<PlatformIconSkeleton />}
            >
              <Image src={platformIcon} className="img-fluid w-100 h-100" />
            </OnImagesLoaded>
          </div>

          <div className="d-flex flex-column w-100">
            <div className="d-flex flex-row w-100 justify-content-between">
              <div className="d-flex flex-column align-items-start ms-2">
                <span className="fw-bold">{profileName}</span>
                <span className="text-muted">
                  {t('lomavisCreator.previewCards.usernameTwitter')}
                </span>
              </div>
              <div>
                <small className="text-black-50">
                  {t('lomavisCreator.previewCards.just_now')}
                </small>
              </div>
            </div>
            <div
              className="d-flex align-items-start mx-2 pt-2 w-100 "
              style={{
                wordBreak: 'break-all',
                whiteSpace: 'pre-wrap'
              }}
            >
              {postText && (
                <span
                  className="preview-text"
                  style={{
                    color: 'black',
                    whiteSpace: 'normal',
                    wordBreak: 'break-word',
                    overflowWrap: 'break-word'
                  }}
                  dangerouslySetInnerHTML={{ __html: postText }}
                />
              )}
            </div>
          </div>
        </div>
        <div className="w-100">
          {mediaFiles.length === 0 && (
            <LinkPreview data={previewUrl} text={postText} platform={TWITTER} />
          )}
        </div>

        {mediaFiles && created_in_lomavis && mediaFiles.length > 0 && (
          <div
            className="asset_wrapper w-100 overflow-hidden"
            style={{
              maxHeight:
                previewMode == PREVIEW_TYPE_COMPACT
                  ? COMPACT_MODE_HEIGHT
                  : '100%'
            }}
          >
            <OnImagesLoaded
              onLoaded={() => {
                setIsImageLoaded(true);
              }}
              placeholder={<PreviewImagesSkeleton />}
            >
              {isImageLoaded && (
                <div
                  style={{ zIndex: 3 }}
                  className="d-flex gap-2 justify-content-center align-items-center position-absolute ms-auto me-3 mt-3 end-0"
                >
                  <div
                    className="viewButton btn btn-sm btn-bg-white border border-dark px-3"
                    style={{
                      zIndex: 3
                    }}
                    aria-haspopup="true"
                    aria-expanded="false"
                    data-image-index="0"
                    data-crop-wrapper-id="facebookCropSlide"
                    data-platform="facebook"
                    onClick={() => viewAssets()}
                  >
                    <i
                      style={{ padding: '0px' }}
                      className="fa-regular fa-eye text-dark"
                    ></i>
                  </div>

                  <AltTagButton platform={platform} />

                  <div
                    className="btn btn-sm btn-bg-white border border-dark cropEditBtn firstImageCropEditBtn"
                    style={{ zIndex: 3 }}
                    aria-haspopup="true"
                    aria-expanded="false"
                    data-image-index="0"
                    data-crop-wrapper-id="facebookCropSlide"
                    data-platform="facebook"
                    onClick={() => previewAssets()}
                  >
                    <span className="loading-indicator spinner-border spinner-border-sm d-none"></span>
                    <span>{t('lomavisCreator.preview.edit')}</span>
                  </div>
                </div>
              )}
              <div
                className={`w-100 ${
                  mediaFiles.length == 1 && previewMode == PREVIEW_TYPE_COMPACT
                    ? 'd-flex justify-content-center'
                    : ''
                }`}
              >
                {mediaFiles &&
                  mediaFiles.length > 0 &&
                  mediaFiles[0].type === 'video' && (
                    <VideoComponent
                      posterUrl={mediaFiles[0]?.custom_thumbnail_url}
                      videoUrl={
                        mediaFiles?.[0]?.file || mediaFiles?.[0]?.video_url
                      }
                      styles={{
                        maxHeight:
                          previewMode == PREVIEW_TYPE_COMPACT
                            ? COMPACT_MODE_HEIGHT
                            : '100%'
                      }}
                    />
                  )}

                {mediaFiles &&
                  mediaFiles.length > 0 &&
                  mediaFiles[0].type === 'image' && (
                    <div
                      className="position-relative overflow-hidden"
                      ref={containerRef}
                      style={{
                        height:
                          mediaFiles.length > 1
                            ? multiImageContainerHeight
                            : '100%'
                      }}
                    >
                      {mediaFiles.map((media, index) => (
                        <div
                          key={index}
                          className={`${
                            mediaFiles.length == 1 ? '' : 'position-absolute'
                          } ${mediaFiles.length >= index + 1 ? '' : 'd-none'}`}
                          style={{
                            inset: insets[`img${index + 1}`]?.inset || '0'
                          }}
                        >
                          <Image
                            className={`img-fluid ${
                              mediaFiles?.length > 1 ? 'w-100 h-100' : ''
                            }`}
                            style={{
                              objectFit: 'cover',
                              borderRadius: '10px',
                              maxHeight:
                                previewMode == PREVIEW_TYPE_COMPACT
                                  ? COMPACT_MODE_HEIGHT
                                  : '100%'
                            }}
                            src={media.image_url}
                          />
                        </div>
                      ))}
                    </div>
                  )}
              </div>
            </OnImagesLoaded>
          </div>
        )}
        {mediaFiles && !created_in_lomavis && mediaFiles.length > 0 && (
          <div
            className="asset_wrapper w-100 overflow-hidden"
            style={{
              maxHeight:
                previewMode == PREVIEW_TYPE_COMPACT
                  ? COMPACT_MODE_HEIGHT
                  : '100%'
            }}
          >
            <ImportedPostsMediaPreview
              platform={platform}
              mediaFiles={mediaFiles}
            />
          </div>
        )}

        <div className="d-flex flex-row justify-content-end px-2 pt-3 border-top align-items-center py-2 px-2">
          <small className="text-mute">
            <FontAwesomeIcon className="me-1" icon={faReply} />
            {t('lomavisCreator.previewCards.reply')}
          </small>
          <small className="text-mute ms-2">
            <FontAwesomeIcon className="me-1" icon={faRetweet} />
            {t('lomavisCreator.previewCards.retweet')}
          </small>
          <small className="text-mute ms-2">
            <FontAwesomeIcon className="me-1" icon={faStar} />
            {t('lomavisCreator.previewCards.favorite')}
          </small>
          <small className="text-mute ms-2">
            <FontAwesomeIcon className="me-1" icon={faEllipsis} />
            {t('lomavisCreator.previewCards.more')}
          </small>
        </div>
      </Card>
    </div>
  );
}
